<template>
  <div class='main_form_block'>
    <div
      class="spinner-border"
      v-if="loader"
      style="margin: auto; display: block; margin-top: 60px"
    />
    <div class="col-sm-12 row" v-else>
      <div class="col-sm-11 vendor-form-wrapper">
        <form v-on:submit.prevent>
          <div class="col-sm-11 divider">
            <label style="margin: 0px">Client</label>
          </div>
          <div
            style="border: 1px #d4d4d4 solid; padding: 20px"
            class="col-md-11"
          >
            <ClientData
              :openAddNewClientPopUp="addNewClient"
              :clientData="clientData"
              :clientList="clientList"
              :isLoadingClient="isLoadingClient"
              @updateClientWithNew="updateClientWithNew"
              @setClient="setClient"
              :client_disable="client_disable"
            />
            <div
              class="form-group row"
              style="margin: 0px"
              v-if="submitted && (!validateClient())"
            >
              <div class="col-sm-3"></div>
              <div class="no-data-style col-sm-7">
                Required fields are missing.
              </div>
            </div>
          </div>

          <!-- Tab bar section starts -->
          <div
            class="col-sm-11 divider"
            v-if="
              profileData.length == 0 &&
              clientData.client &&
              clientData.client != null
            "
          ></div>
          <div
            class="form-group row center"
            v-if="
              profileData.length == 0 &&
              clientData.client &&
              clientData.client != null
            "
            style="margin-left: 0px"
          >
            <button
              class="btn btn-primary add-new-campaign btn-margin"
              @click="addProfileToList('Ad Accounts')"
              style="margin-top:10px !important"
            >
              Add AMZ Ad Account
            </button>
            <button
              @click="addProfileToList('Seller')"
              class="btn btn-primary add-new-campaign btn-margin"
              style="margin-top:10px !important"
            >
              Add AMZ Seller Account
            </button>
            <button
              class="btn btn-primary add-new-campaign btn-margin"
              @click="addProfileToList('Vendor')"
              style="margin-top:10px !important"
            >
              Add AMZ Vendor Account
            </button>
            <button
              class="btn btn-primary add-new-campaign btn-margin"
              @click="addProfileToList('DSP Accounts');disableDSP=true"
              style="margin-top:10px !important"
            >
              Add AMZ DSP Advertising Account
            </button>
          </div>
          <div
            class="col-sm-11 divider"
            v-if="
              profileData.length == 0 &&
              clientData.client &&
              clientData.client != null
            "
            style="margin-top: 0px"
          ></div>
          <!-- Tab bar section ends -->

          <!-- Association section starts -->
          <div
            v-for="(profile, index) in profileData"
            :key="index"
            class="form-group row"
            style="margin: 0px"
          >
            <div class="col-sm-11 divider">
              <label style="margin: 0px" class="uppercase">{{
                profile.type
              }}</label>
            </div>

            <!-- add amazon ad account section starts -->
            <div
              v-if="profile.type && profile.type == 'Ad Accounts'"
              style="
                border: 1px #d4d4d4 solid;
                padding: 20px;
                margin-bottom: 20px;
              "
              class="col-md-11"
              :class="{ 'change-color': currentProfile == profile.profile_id }"
              :key="'profile_' + index"
              :id="'vendor_' + index"
            >
              <AdAccountData
                :brandsList="addCustomLabel(brandsList)"
                @getBrandForId="getBrandForId"
                :profile="profile"
                :index="index"
                :noDateForActiveFalse="noDateForActiveFalse"
                @updateDisableDate="updateDisableDate"
                :client_id="client_id"
                :vendorList="vendorList"
                :sellerList="sellerList"
                @removeDate="removeDate"
                @dateProvideDisableVAlidation="dateProvideDisableVAlidation"
              />
            </div>
            <!-- add amazon ad account section ends -->

            <!-- add amazon seller account section starts -->
            <div
              v-if="profile.type && profile.type == 'Seller'"
              style="
                border: 1px #d4d4d4 solid;
                padding: 20px;
                margin-bottom: 20px;
              "
              class="col-md-11"
              :class="{ 'change-color': currentProfile == profile.profile_id }"
              :key="'profile_' + index"
              :id="'vendor_' + index"
            >
              <AmazonSellerData
                :profile="profile"
                :index="index"
                :sellerList="sellerList"
                @sellerUpdated='sellerUpdated'
                @openSellerPopUp="openSellerPopUp"
                :noDateForActiveFalse="noDateForActiveFalse"
                @updateDisableDate="updateDisableDate"
                @removeDate="removeDate"
                @dateProvideDisableVAlidation="dateProvideDisableVAlidation"
                @convertToUniqueSellerDataSet="convertToUniqueSellerDataSet"
              />
            </div>
            <!-- add amazon seller account section ends -->

            <!-- add amazon vendor account section starts -->
            <div
              v-if="profile.type && profile.type == 'Vendor'"
              style="
                border: 1px #d4d4d4 solid;
                padding: 20px;
                margin-bottom: 20px;
              "
              class="col-md-11"
              :class="{ 'change-color': currentProfile == profile.profile_id }"
              :key="'profile_' + index"
              :id="'vendor_' + index"
            >
              <AmazonVendorData
                :profile="profile"
                :index="index"
                :vendorList="vendorList"
                @vendorUpdated='vendorUpdated'
                @openVendorPopUp="openVendorPopUp"
                :noDateForActiveFalse="noDateForActiveFalse"
                @updateDisableDate="updateDisableDate"
                @removeDate="removeDate"
                @dateProvideDisableVAlidation="dateProvideDisableVAlidation"
                @convertToUniqueVendorDataSet="convertToUniqueVendorDataSet"
              />
            </div>
            <!-- add amazon vendor account section ends -->

            <!-- add amazon dsp account section starts -->
            <div
              v-if="profile.type && profile.type == 'DSP Accounts'"
              style="
                border: 1px #d4d4d4 solid;
                padding: 20px;
                margin-bottom: 20px;
              "
              class="col-md-11"
              :class="{ 'change-color': currentProfile == profile.profile_id }"
              :key="'profile_' + index"
              :id="'vendor_' + index"
            >
              <DSPAccountData
                :profile="profile"
                :index="index"
                :DSPList="pickDSPSelectList(index)"
                :noDateForActiveFalse="noDateForActiveFalse"
                @openDSPPopUp="openDSPPopUp"
                @updateDisableDate="updateDisableDate"
                @toggleAdAgencyDD="toggleAdAgencyDD"
                @removeDate="removeDate"
                @dateProvideDisableVAlidation="dateProvideDisableVAlidation"
                @DSPUpdated="DSPUpdated"
                @convertToUniqueDSPDataSet="convertToUniqueDSPDataSet"
              />
            </div>

            <!-- add amazon Instacart Account section start -->
            <div
              v-if="profile.type && profile.type == 'Instacart Accounts'"
              style="
                border: 1px #d4d4d4 solid;
                padding: 20px;
                margin-bottom: 20px;
              "
              class="col-md-11"
              :class="{ 'change-color': currentProfile == profile.profile_id }"
              :key="'profile_' + index"
              :id="'vendor_' + index"
            >
              <InstacartAccountData
                :instacartList="instacarts"
                :profile="profile"
                :index="index"
                :noDateForActiveFalse="noDateForActiveFalse"
                :type="'add'"
                :client_id="client_id"
                @updateDisableDate="updateDisableDate"
                @removeDate="removeDate"
                @dateProvideDisableVAlidation="dateProvideDisableVAlidation"
                @instacartUpdated="instacartUpdated"
                @openInstacartPopUp="openInstacartPopUp"
                @convertToUniqueInstaCartDataSet="convertToUniqueInstaCartDataSet"
              />
            </div>
            <div
              v-if="profile.type && profile.type != 'Profiles'"
              class="col-sm-1"
            >
              <button
                @click="removeProfileToList(index)"
                class="btn btn-primary add-new-campaign"
                style="background-color: red"
              >
                X
              </button>
            </div>
          </div>
          <!-- association section ends -->

          <!-- tab bar footer section starts -->
          <div
            class="col-sm-11 divider"
            v-if="
              profileData.length &&
              clientData.client &&
              clientData.client != null
            "
          ></div>

          <div
            class="form-group row "
            style="margin-left: auto;margin-right: auto;display: block;text-align: center;width: 890px;"
            v-if="profileData.length"
          >
            <button
              class="btn btn-primary add-new-campaign btn-margin"
              v-if="clientData.client && clientData.client != null"
              @click="addProfileToList('Ad Accounts')"
              style="margin-top:10px !important"
            >
              Add AMZ Ad Account
            </button>
            <button
              @click="addProfileToList('Seller')"
              class="btn btn-primary add-new-campaign btn-margin"
              v-if="clientData.client && clientData.client != null"
              style="margin-top:10px !important"
            >
              Add AMZ Seller Account
            </button>
            <button
              class="btn btn-primary add-new-campaign btn-margin"
              v-if="clientData.client && clientData.client != null"
              @click="addProfileToList('Vendor')"
              style="margin-top:10px !important"
            >
              Add AMZ Vendor Account
            </button>
            <button
              class="btn btn-primary add-new-campaign btn-margin"
              v-if="clientData.client && clientData.client != null"
              @click="addProfileToList('DSP Accounts');disableDSP=true"
              style="margin-top:10px !important"
            >
              Add AMZ DSP Advertising Account
            </button>
          </div>
          <div
            class="col-sm-11 divider"
            v-if="
              profileData.length &&
              clientData.client &&
              clientData.client != null
            "
            style="margin-top: 0px !important"
          ></div>
          <!-- Tab bar footer section ends -->

          <span
            class="no-data-style"
            v-if="profileWithoutData && !activeProfileWithoutData"
          >
            Add Vendor or Seller to the profile marked true
          </span>

          <span class="no-data-style" v-if="activeProfileWithoutData">
            Add Vendor or Seller to the profile marked with active true
          </span>
          <span class="no-data-style" v-if="submitted && !validateSections()">
            Please check data for required fields.
          </span>

          <div
            class="form-group text-center"
            style="margin-top: 20px; margin-bottom: 20px"
          >
            <button
              class="btn btn-secondary"
              @click="navigateToListPage()"
            >
              Cancel
            </button>
            <button class="btn btn-primary" @click="saveVendor()">Save</button>
          </div>
        </form>
      </div>
    </div>
    <!-- to add a new vendor data-->
    <VendorPopUp
      :vendorList="vendorListCopy"
      @updateVendorList="updateVendorList"
      :index="selectedVendorIndex"
      @updateCancelVendorList="updateCancelVendorList"
    />
    
    <!-- to add a new seller data -->
    <SellerPopUp
      :index="selectedSellerIndex"
      @updateSellerList="updateSellerList"
      :sellerList="sellerListCopy"
      @updateAddedCancelSellerInfo="updateAddedCancelSellerInfo"
    />
    <!-- to add a new instacart data -->
    <InstacartPopUp
      @updateAddedInstacartInfo="updateAddedInstacartInfo"
      :index="selectedInstacartIndex"
      :instacartList="instacartsCopy"
    />
    <DSPPopUp
    @updateAddedDSPInfo="updateAddedDSPInfo"
    :client_id= "client_id"
    :index="selectedDSPIndex"
    :DSPList="pickDSPSelectList()"
    />
    
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import AddContactModal from "@/components/account-management/AddContactModal";
import VendorPopUp from "@/components/account-management/VendorPopUp.vue";
import SellerPopUp from "@/components/account-management/SellerPopUp.vue";
import InstacartPopUp from "@/components/account-management/InstacartPopUp.vue";
import DSPPopUp from "@/components/account-management/DSPPopUp.vue";
import ProfileData from "@/components/account-management/ProfileData.vue"; 
import ClientData from "@/components/account-management/ClientData.vue";
import moment from "moment";
import datePicker from "vue-bootstrap-datetimepicker";
import AdAccountData from "@/components/account-management/AdAccountData.vue";
import DSPAccountData from "@/components/account-management/DSPAccountData.vue";
import InstacartAccountData from "@/components/account-management/InstacartAccountData.vue";
import AmazonSellerData from "@/components/account-management/AmazonSellerData.vue";
import AmazonVendorData from "@/components/account-management/AmazonVendorData.vue";

export default {
  name: "AddVendorForm3",
  data() {
    return {
      disableDSP:false,
      addNewClient: false,
      loader: false,
      profileData: [
        {
          profile_id: "",
          vendor: null,
          seller: null,
          go_vendor_cd: "",
          ams_profile_id: "",
          brand_entity_id: "",
          profile_brand_name: "",
          active: true,
          country_code: "",
          base_api_url: "",
          profile_type_seller: false,
          profile_type_vendor: false,
          marketing_campaign_sp: "",
          marketing_campaign_sb: "",
          marketing_campaign_sd: "",
          ara_type: "",
          client_main_contact: "",
          profile_type: "",
          data_pull: "",
          go_marketing: "",
          go_retail:'',
          go_ops:'',
          go_brand:"",
          go_dsp:"",
          go_media:"",
          go_content:"",
          go_ba:"",
          go_Other:"",
          go_initiative:"",
          annual_goal: "",
          fba: "",
          montly_budget: "",
          disable_date: "",
          selected_profile: null,
          showProfileInfo: false,
          gettingProfileInfo: false,
          showDate: false,
          showSeller: false,
          showVendor: false,
          noData: false,
          duplicateProfile: false,
        },
      ],
      clientData: {
        client: null,
        client_name: "",
        go_ops: "",
        go_marketing: "",
        go_retail: "",
        partner_uuid:"",
        sharepoint_link:"",
        go_brand:"",
				go_dsp:"",
				go_media:"",
				go_content:"",
				go_ba:"",
				go_Other:"",
				go_initiative:""
      },
      client_disable: false,
      client_id: "",
      brandProfileId: "",
      currentProfile: "",
      brandsList: [],
      brandsListCopy: [],
      clientList: [],
      isLoadingClient: false,
      vendorList: [],
      vendorListCopy: [],
      sellerList: [],
      sellerListCopy: [],
      selectedInstacartProfile: {},
      selectedInstacartIndex: -1,
      selectedDSPIndex:-1,
      sellerActionType: "",
      instacartActionType: "",
      selectedVendorIndex: "",
      selectedSellerIndex: "",
      submitted: false,
      tempProfile: {},
      addedNewVendor: {},
      addedNewSeller: {},
      profileWithoutData: false,
      activeProfileWithoutData: false,
      noDateForActiveFalse: -1,
      instacarts: [],
      instacartsCopy: [],
      DSPs:[],
      DSPCopy:[],
      AgencyDSPs:[],
      AgencyDSPCopy:[]
    };
  },
  components: {
    Multiselect,
    AddContactModal,
    datePicker,
    AddContactModal,
    VendorPopUp,
    ProfileData,
    ClientData,
    VendorPopUp,
    SellerPopUp,
    InstacartPopUp,
    AdAccountData,
    DSPAccountData,
    InstacartAccountData,
    AmazonSellerData,
    AmazonVendorData,
    DSPPopUp
  },
  computed: {
    min_date() {
      return moment().format("YYYY-MM-DD");
    },
    min_date_disable() {
      //only allow future dates, will prevent past as well as current date from selection
      return moment().add(1, "days").format("YYYY-MM-DD");
    },
  },
  watch: {},
  async mounted() {
      if (this.$store.state.isUserAdmin) {
        this.$store.dispatch("callAnalytics", {
        data: window.location.href,
        this: this,
        type: "AddEditAccount"});
      } else {
        this.$router.push({ path: "/productList" });
      }

    //   -- old hacky auth gate --
		// 	if(userName!='Chris Goggin') {
		// 		this.$router.push({ path: "/productList" });
		// 	}
    // this.$store.dispatch("callAnalytics", {
    //   data: window.location.href,
    //   this: this,
    //   type: "AddEditAccount",
    // });

    if (this.$route.fullPath == "/addVendor") {
      this.addNewClient = true;
    } else {
      this.addNewClient = false;
    }
    const vm = this
    this.currentProfile = this.$route.params.ProfileId;
    this.isLoadingClient = true;
    this.loader = true
    let brand = this.$store
        .dispatch("getAllBrandProfile", { includeActiveFalse: true }) 
        .then((res) => {
          vm.brandsList = JSON.parse(JSON.stringify(res));
          vm.brandsListCopy = JSON.parse(JSON.stringify(res)); 
          console.log('brand fetched')
        })
        
    let client = this.$store.dispatch("getAccountClient").then((res) => {
        vm.clientList = res.filter((e) => e.client_name);
        vm.isLoadingClient = false;
        console.log('client fetched')
      })
      
    let vendor = this.$store.dispatch("getAccountVendors").then((res) => {
        vm.vendorList = res.filter((e) => e.vendor_name && e.vendor_id);
        vm.vendorListCopy = JSON.parse(JSON.stringify(vm.vendorList));
        console.log('vendor fetched')
      })
      
    let seller = this.$store.dispatch("accounts/getMerchantNameList").then((res) => {
        this.sellerList = JSON.parse(JSON.stringify(res));
        this.sellerListCopy = JSON.parse(JSON.stringify(res));
        console.log('seller fetched')
      })
      
    let instacart = this.$store.dispatch("accounts/getAllInstacart").then((res) => {
        this.instacarts = res.data.filter((e) => e.instacart_profile_name && e.instacart_profile_id);
        this.instacartsCopy = JSON.parse(JSON.stringify(this.instacarts));
        console.log('instacart fetched')
      })
      
    let dsp = this.$store.dispatch("accounts/getAllDSP").then((res) => {
        this.DSPs = res.data.filter((e) => e.advertiser_id && e.advertiser_name);
        this.DSPCopy = JSON.parse(JSON.stringify(this.DSPs));
        console.log('DSP fetched')
      })
      
    let agencydsp = this.$store.dispatch("accounts/getAgencyDSP").then((res) => {
        this.AgencyDSPs = res.data.filter((e) => e.advertiser_id && e.advertiser_name);
        this.AgencyDSPCopy = JSON.parse(JSON.stringify(this.AgencyDSPs));
        console.log('Agency DSP fetched')
      });
      
      
      await Promise.all([brand,client,vendor,seller,instacart,dsp,agencydsp]).then(()=>{
      vm.loader = false
      console.log('all fetched');
      vm.checkIsClient()
    })
  },
  methods: {
    vendorUpdated(obj){
      let index = obj.index;
      let date = obj.date;
	    obj.selected.go_client_id = this.client_id
      if (
        this.profileData[index].type == "Vendor" &&
        Object.keys(this.profileData[index].selected_profile).length
      ) {
        this.convertToUniqueVendorDataSet(
          this.profileData[index].selected_profile.vendor_id.toString().trim(),
          'remove'
        );
      }
      
      this.profileData[index]["selected_profile"] = obj.selected;
      this.profileData[index]["annual_goal"] = obj.annual_goal||'';
      this.profileData[index]["active"] = obj.active;
      this.profileData[index]['country_code'] = obj.country_code
      this.profileData[index]['id'] = (obj.selected||{}).id
      this.profileData[index]['prev_go_client_id'] = obj.prev_go_client_id
      this.profileData[index]['partner_uuid'] = obj.partner_uuid
      this.profileData[index]['go_retail'] = obj.go_retail
      this.profileData[index]['go_marketing'] = obj.go_marketing
      this.profileData[index]['go_ops'] = obj.go_ops
      this.profileData[index]['go_brand'] = obj.go_brand
      this.profileData[index]['go_dsp'] = obj.go_dsp
      this.profileData[index]['go_media'] = obj.go_media
      this.profileData[index]['go_content'] = obj.go_content
      this.profileData[index]['go_ba'] = obj.go_ba
      this.profileData[index]['go_Other'] = obj.go_Other
      this.profileData[index]['go_initiative'] = obj.go_initiative
      
      if (date) {
        this.profileData[index].showDate = true;
        this.profileData[index].disable_date = moment(date)
          .utc()
          .format("YYYY-MM-DD");
      } else {
        this.profileData[index].showDate = false;
        this.profileData[index].disable_date = "";
      }
      this.convertToUniqueVendorDataSet(
        obj.selected.vendor_id,
        "add"
      );
      this.vendorList.splice(0, 0);
    },
    sellerUpdated(obj){
      let index = obj.index;
      let date = obj.date;
	    obj.selected.go_client_id = this.client_id
      if (
        this.profileData[index].type == "Seller" &&
        Object.keys(this.profileData[index].selected_profile).length
      ) {
        this.convertToUniqueSellerDataSet(
          this.profileData[index].selected_profile.id.toString().trim(),
          'remove'
        );
      }
      this.profileData[index]["selected_profile"] = obj.selected;
      this.profileData[index]["annual_goal"] = obj.annual_goal||'';
      this.profileData[index]["active"] = obj.active;
      this.profileData[index]["fba"] = obj.fba;
      this.profileData[index]['country_code'] = obj.country_code
      this.profileData[index]['id'] = (obj.selected||{}).id
      this.profileData[index]['prev_go_client_id'] = obj.prev_go_client_id
      this.profileData[index]['partner_uuid'] = obj.partner_uuid
      this.profileData[index]['go_retail'] = obj.go_retail
      this.profileData[index]['go_marketing'] = obj.go_marketing
      this.profileData[index]['go_ops'] = obj.go_ops

      if (date) {
        this.profileData[index].showDate = true;
        this.profileData[index].disable_date = moment(date)
          .utc()
          .format("YYYY-MM-DD");
      } else {
        this.profileData[index].showDate = false;
        this.profileData[index].disable_date = "";
      }
      this.convertToUniqueSellerDataSet(
        obj.selected.id,
        "add"
      );
      this.sellerList.splice(0, 0);
    },
    instacartUpdated(obj) {
      let index = obj.index;
      let date = obj.date;
	    obj.selected.go_client_id = this.client_id
      if (
        this.profileData[index].type == "Instacart Accounts" &&
        Object.keys(this.profileData[index].selected_profile).length
      ) {
        this.convertToUniqueInstaCartDataSet(this.profileData[index].selected_profile.instacart_profile_id.toString().trim(),'remove');
      }
      this.profileData[index]["selected_profile"] = obj.selected;
      this.profileData[index]["profile_id"] = obj.selected.profile_id;
      this.profileData[index]["active"] = obj.active;
      this.profileData[index]['prev_go_client_id'] = obj.prev_go_client_id

      if (date) {
        this.profileData[index].showDate = true;
        this.profileData[index].disable_date = moment(date)
          .utc()
          .format("YYYY-MM-DD");
      } else {
        this.profileData[index].showDate = false;
        this.profileData[index].disable_date = "";
      }
      this.convertToUniqueInstaCartDataSet(
        obj.selected.instacart_profile_id,
        "add"
      );
      this.instacarts.splice(0, 0);
    },
    DSPUpdated(obj) {
      let index = obj.index;
      let date = obj.date;
	    obj.selected.go_client_id = this.client_id
      this.profileData[index]["selected_profile"] = obj.selected;
      this.profileData[index]["active"] = obj.selected.active;
      this.profileData[index]['prev_go_client_id'] = obj.prev_go_client_id

      if (date) {
        this.profileData[index].showDate = true;
        this.profileData[index].disable_date = moment(date)
          .utc()
          .format("YYYY-MM-DD");
      } else {
        this.profileData[index].showDate = false;
        this.profileData[index].disable_date = "";
      }
      this.convertToUniqueDSPDataSet(
        obj.selected.advertiser_id,
        "add"

      );
      this.DSPs.splice(0, 0);
    },
    getInstacartList() {
      this.$store.dispatch("accounts/getAllInstacart").then((res) => {
        this.instacarts = res.data.filter((e) => e.instacart_profile_name && e.instacart_profile_id);
        this.instacartsCopy = JSON.parse(JSON.stringify(this.instacarts));
      });
      return this.instacarts;
    },
    getDSPList() {
      this.$store.dispatch("accounts/getAllDSP").then((res) => {
        this.DSPs = res.data.filter((e) => e.advertiser_id && e.advertiser_name);
        this.DSPCopy = JSON.parse(JSON.stringify(this.DSPs));
      });
      
      return this.DSPs;
    },
    getAgencyDSPList() {
      this.$store.dispatch("accounts/getAgencyDSP").then((res) => {
        this.AgencyDSPs = res.data.filter((e) => e.advertiser_id && e.advertiser_name);
        this.AgencyDSPCopy = JSON.parse(JSON.stringify(this.AgencyDSPs));
      });
      
      return this.AgencyDSPs;
    },
    dateProvideDisableVAlidation(data) {
      this.noDateForActiveFalse = data;
    },
    pickDSPSelectList(index) {
      if (this.profileData && this.profileData[index] && this.profileData[index].isAgency) {
        return this.AgencyDSPs
      }
      return this.DSPs
    },
    addCustomLabel(brandsList) {  // TODO here is the string concatenation for profile drop down
      if (!Array.isArray(brandsList)) {
        brandsList["customName"] =
          brandsList["profile_brand_name"] +
          " (" +
          brandsList["brand_entity_id"] +
          ") " +
          brandsList["country_code"];
        return brandsList;
      } else {
        let newArr = brandsList.map((item) => {  // here is initial list propagation
          let apiAccount = (item["api_account"].includes("two") ? "api-2" : "api-1")
          let name = item["name"] ? item["name"] + " (" : "";
          name = name + item["brand_entity_id"] + (item["name"] ? ") " + item["country_code"] : "") + " " + apiAccount
          item["customName"] = name;
          return item;
        });
        return newArr;
      }
    },
    updateProfileForceFully(val, index) {
      let data = JSON.parse(JSON.stringify(this.profileData));
      data[index] = val;
      this.profileData = JSON.parse(JSON.stringify(data));
      this.activeProfileWithoutData = false;
    },
    checkIsClient() {
      let id = this.$route.params.ProfileId;
      let brandId = this.$route.params.BrandProfileId;
      if (id) {
        this.client_id = id;
        this.client_disable = true;
        // this.getProfileData();
        this.fetchAllAmSections()
      } else if (brandId) {
        this.client_id = "";
        this.brandProfileId = brandId;
        this.getBrandForId(this.brandProfileId, 0);
      }
    },
    getClientList() {
      this.isLoadingClient = true;
      const vm = this;
      this.$store.dispatch("getAccountClient").then((res) => {
        vm.clientList = res.filter((e) => e.client_name);
        vm.isLoadingClient = false;
      });
    },
    getBrandForId(data, index, type) {
      let vm = this;
      let payload = {
        profile_id: data,
      };
      this.profileData[index].gettingProfileInfo = true;
      this.profileData[index].nodata = false;
      this.$store
        .dispatch("accounts/getVendorDataById", payload)
        .then((res) => {
          vm.tempProfile = res;
          vm.profileData[index] = res;
          type ? (vm.profileData[index]["type"] = type) : "";
          let seletedData = vm.brandsList.find((e) => e.id == res.profile_id);
          vm.profileData[index].selected_profile = seletedData;
          vm.profileData[index].showProfileInfo = true;
          vm.profileData[index].prev_go_client_id = res.go_client_id
          if (vm.profileData && vm.profileData[index].disable_date) {
            vm.profileData[index].showDate = true;
            vm.profileData[index].disable_date = moment(res.disable_date)
              .utc()
              .format("YYYY-MM-DD");
          }
          
          this.profileData[index].gettingProfileInfo = false;
          vm.profileData.splice(0, 0);
          vm.convertToUniqueDataSet(
            res.profile_id,
            "add"
          );
        });
    },
    getBrandsList() {
      let vm = this;
      this.$store
        .dispatch("getAllBrandProfile", { includeActiveFalse: true })
        .then((res) => {
          vm.brandsList = JSON.parse(JSON.stringify(res));
          vm.brandsListCopy = JSON.parse(JSON.stringify(res));
          vm.checkIsClient();
        });
    },
    updateDisableDate(index, val) {
      let data = JSON.parse(JSON.stringify(this.profileData));
      data[index].showDate = val;
      if (val == false) {
        data[index].disable_date = "";
      }
      this.profileData = JSON.parse(JSON.stringify(data));
    },
    toggleAdAgencyDD(index, val) {
      let data = JSON.parse(JSON.stringify(this.profileData));
      console.log(val)
      
      if (val == false) {
        data[index].DSPList = JSON.parse(JSON.stringify(this.DSPs))
      } else {
        data[index].DSPList = JSON.parse(JSON.stringify(this.AgencyDSPs))
      }
      this.profileData = JSON.parse(JSON.stringify(data))
    },
    addProfileToList(type) {
      let obj = {
        profile_id: "",
        vendor: null,
        seller: null,
        go_vendor_cd: "",
        ams_profile_id: "",
        brand_entity_id: "",
        profile_brand_name: "",
        active: true,
        country_code: "",
        base_api_url: "",
        profile_type_seller: false,
        profile_type_vendor: false,
        marketing_campaign_sp: "",
        marketing_campaign_sb: "",
        marketing_campaign_sd: "",
        ara_type: "",
        client_main_contact: "",
        profile_type: "",
        isAgencyAccount: false,
        data_pull: "",
        go_retail: "",
        go_vendor: "",
        go_marketing: "",
        go_ops: "",
        go_brand:"",
				go_dsp:"",
				go_media:"",
				go_content:"",
				go_ba:"",
				go_Other:"",
				go_initiative:"",
        annual_goal: "",
        fba: "",
        montly_budget: "",
        disable_date: "",
        selected_profile: {},
        showProfileInfo: false,
        gettingProfileInfo: false,
        showDate: false,
        showSeller: false,
        showVendor: false,
        noData: false,
        duplicateProfile: false,
        type: type,
      };

      this.profileData.push(obj);
    },
    removeProfileToList(index) {
      this.activeProfileWithoutData = false;
      this.profileWithoutData = false;
      this.profileData[index].noData = false;
      let profile = this.profileData[index];
      if (
        profile.type == "Instacart Accounts" &&
        Object.keys(profile.selected_profile).length
      ) {
        this.convertToUniqueInstaCartDataSet(
          profile.selected_profile.instacart_profile_id.toString().trim(),
          "remove"
        );
      }
      else if (
        profile.type == "Vendor" &&
        Object.keys(profile.selected_profile).length
      ) {
        this.convertToUniqueVendorDataSet(
          profile.selected_profile.vendor_id.toString().trim(),
          "remove"
        );
      }
      else if (
        profile.type == "Seller" &&
        Object.keys(profile.selected_profile).length
      ) {
        this.convertToUniqueSellerDataSet(
          profile.selected_profile.id.toString().trim(),
          "remove"
        );
      }
      else if (
        profile.type == "DSP Accounts"
      ) {
        this.disableDSP = false
        if(Object.keys(profile.selected_profile).length){
            this.convertToUniqueDSPDataSet(
            profile.selected_profile.advertiser_id.toString().trim(),
            "remove"
          );
        }
        
      }
       else if (profile.profile_brand_name) {
        this.convertToUniqueDataSet(
          profile.profile_id.toString().trim(),
          "remove"
        );
      }
      this.profileData.splice(index, 1);
    },
    convertToUniqueInstaCartDataSet(id, type) {
      let list = []
      if(type=='remove'){
        list = JSON.parse(JSON.stringify(this.instacartsCopy));
      }
      else{
        list = JSON.parse(JSON.stringify(this.instacarts));
      }
      let isPresent = list.findIndex((e) => e.instacart_profile_id == id);
      isPresent = isPresent || isPresent == 0 ? isPresent : -1;
      if (type == "add" && isPresent != -1) {
        list.splice(isPresent, 1);
        this.instacarts = JSON.parse(JSON.stringify(list));
      } else if (type == "remove" && isPresent != -1) {
        this.instacarts.push(list[isPresent]);
      }
    },
    convertToUniqueDataSet(id,type){
      let list = []
      if(type=='remove'){
        list = JSON.parse(JSON.stringify(this.brandsListCopy));
      }
      else{
        list = JSON.parse(JSON.stringify(this.brandsList));
      }
      let isPresent = list.findIndex((e) => e.id == id);
      isPresent = isPresent || isPresent == 0 ? isPresent : -1;
      if (type == "add" && isPresent != -1) {
        list.splice(isPresent, 1);
        this.brandsList = JSON.parse(JSON.stringify(list));

      } else if (type == "remove" && isPresent != -1) {
        this.brandsList.push(list[isPresent]);
      }
    },
    convertToUniqueDSPDataSet(id, type) {
      let list = []
      if(type=='remove'){
        list = JSON.parse(JSON.stringify(this.DSPCopy));
      }
      else{
        list = JSON.parse(JSON.stringify(this.DSPs));
      }
      let isPresent = list.findIndex((e) => e.advertiser_id == id);
      isPresent = isPresent || isPresent == 0 ? isPresent : -1;
      if (type == "add" && isPresent != -1) {
        list.splice(isPresent, 1);
        this.DSPs = JSON.parse(JSON.stringify(list));

      } else if (type == "remove" && isPresent != -1) {
        this.DSPs.push(list[isPresent]);
      }
    },
    convertToUniqueAgencyDSPDataSet(id, type) {
      let list = []
      if(type=='remove'){
        list = JSON.parse(JSON.stringify(this.AgencyDSPCopy));
      }
      else{
        list = JSON.parse(JSON.stringify(this.AgencyDSPs));
      }
      let isPresent = list.findIndex((e) => e.advertiser_id == id);
      isPresent = isPresent || isPresent == 0 ? isPresent : -1;
      if (type == "add" && isPresent != -1) {
        list.splice(isPresent, 1);
        this.DSPs = JSON.parse(JSON.stringify(list));

      } else if (type == "remove" && isPresent != -1) {
        this.AgencyDSPs.push(list[isPresent]);
      }
    },
    convertToUniqueVendorDataSet(vendor_id, type) {
      let list = []
      if(type=='remove'){
        list = JSON.parse(JSON.stringify(this.vendorListCopy));
      }
      else{
        list = JSON.parse(JSON.stringify(this.vendorList));
      }
      let isPresent = list.findIndex((e) => e.vendor_id == vendor_id);
      isPresent = isPresent || isPresent == 0 ? isPresent : -1;
      if (type == "add" && isPresent != -1) {
        list.splice(isPresent, 1);
        this.vendorList = JSON.parse(JSON.stringify(list));
      } else if (type == "remove" && isPresent != -1) {
        this.vendorList.push(list[isPresent]);
      }
    },
    convertToUniqueSellerDataSet(id, type) {
      let list = []
      if(type=='remove'){
        list = JSON.parse(JSON.stringify(this.sellerListCopy));
      }
      else{
        list = JSON.parse(JSON.stringify(this.sellerList));
      }
      let isPresent = list.findIndex((e) => e.id == id);
      isPresent = isPresent || isPresent == 0 ? isPresent : -1;
      if (type == "add" && isPresent != -1) {
        list.splice(isPresent, 1);
        this.sellerList = JSON.parse(JSON.stringify(list));
      } else if (type == "remove" && isPresent != -1) {
        this.sellerList.push(list[isPresent]);
      }
    },
    updateClientWithNew(data) {
	  this.client_id = data?data.client_id:''
      this.clientList.push(data);
    },
    setClient(id) {
      this.client_id = id;
      // this.getProfileData();
      this.fetchAllAmSections()
    },
    getVendorList() {
      const vm = this;
      this.$store.dispatch("getAccountVendors").then((res) => {
        vm.vendorList = res.filter((e) => e.vendor_name);
        vm.vendorListCopy = JSON.parse(JSON.stringify(vm.vendorList));
      });
    },
    openVendorPopUp(index) {
      this.selectedVendorIndex = index;
      if(this.selectedVendorIndex !=-1)
      $("#vendorPopUp").modal("show");
    },
    openSellerPopUp(index) {
      this.selectedSellerIndex = index;
      if(this.selectedSellerIndex !=-1)
      $("#sellerPopUp").modal("show");
    },
    openInstacartPopUp(index) {
      this.selectedInstacartIndex = index;
      if(this.selectedInstacartIndex !=-1)
      $("#instacartPopUp").modal("show");
    },
    openDSPPopUp(index) {
      this.selectedDSPIndex = index;
      if(this.selectedDSPIndex !=-1)
      $("#DSPPopUp").modal("show");
    },
    updateAddedInstacartInfo(data, index) {
      $("#instacartPopUp").modal("hide");
      this.instacartsCopy.push(data);
      this.instacarts.push(data);
      let obj = {
        date: data.disable_date,
        index: index,
        selected: data,
        active:data.active,
        prev_go_client_id:data.go_client_id
      };
      this.instacartUpdated(obj);
      this.selectedInstacartIndex = -1
    },
    updateAddedDSPInfo(data, index) {
      $("#DSPPopUp").modal("hide");
      if (this.isAgency) {
        this.AgencyDSPCopy.push(data);
        this.AgencyDSPs.push(data);
      } else {
        this.DSPCopy.push(data);
        this.DSPs.push(data);
      }
      let obj = {
        date: data.disable_date,
        index: index,
        selected: data,
      };
      this.DSPUpdated(obj);
      this.selectedDSPIndex = -1
    },
    updateAddedCancelSellerInfo(data, type, profileIndex) {
      $("#sellerPopUp").modal("hide");
      this.profileData[profileIndex].merchant_new = "";
      this.profileData[profileIndex].seller = null;

      let updateData = JSON.parse(JSON.stringify(this.profileData));
      this.profileData = JSON.parse(JSON.stringify(updateData));
    },
    updateCancelVendorList() {
      $("#vendorPopUp").modal("hide");
    },
    updateVendorList(data, index) {
      $("#vendorPopUp").modal("hide");
      this.vendorListCopy.push(data);
      this.vendorList.push(data);
      let obj = {
        date: data.disable_date,
        index: index,
        selected: data,
        annual_goal : data.annual_goal,
        active:data.active,
        country_code:data.country_code,
        prev_go_client_id: data.go_client_id,
        partner_uuid: data.partner_uuid,
        go_retail: data.go_retail,
        go_marketing: data.go_marketing,
        go_ops: data.go_ops
      };
      this.vendorUpdated(obj);
      this.selectedVendorIndex = -1
    },
    updateSellerList(data, index) {
      $("#sellerPopUp").modal("hide");
      this.sellerListCopy.push(data);
      this.sellerList.push(data);
      let obj = {
        date: data.disable_date,
        index: index,
        selected: data,
        annual_goal : data.fba,
        active:data.active,
        fba:data.fba,
        country_code:data.country_code,
        prev_go_client_id: data.go_client_id,
        partner_uuid: data.partner_uuid,
        go_retail: data.go_retail,
        go_marketing: data.go_marketing,
        go_ops: data.go_ops
      
      };
      this.sellerUpdated(obj);
      this.selectedSellerIndex = -1
    },
    getSellerList() {
      this.$store.dispatch("accounts/getMerchantNameList").then((res) => {
        this.sellerList = JSON.parse(JSON.stringify(res));
        this.sellerListCopy = JSON.parse(JSON.stringify(res));
      });
    },
    navigateToListPage(data) {
      if (data == "cancel") {
        this.$store.state.calledFromCancel = true;
      }
      this.$router.push({ path: "/accounts" });
    },
    validateSharePoint(data){
      let userInput = data.sharepoint_link ? data.sharepoint_link : null
      if(userInput==null){
        return true;
      }
				var res = userInput.match(/(http(s)?:\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
				if(res == null){
					return false;
				}
				else{
					return true;
				}
    },
    saveVendor() {
      let vm = this;
      this.submitted = true;
      this.profileWithoutData = false;

      if (this.validateClient(true) && this.validateSections() && this.validateSharePoint(this.clientData)) {
        this.clientData.go_retail =
          (this.clientData.go_retail || {}).id || this.clientData.go_retail;
        if (
          this.clientData.go_retail == undefined ||
          this.clientData.go_retail == ""
        ) {
          this.clientData.go_retail = null;
        }
        this.clientData.go_ops =
          (this.clientData.go_ops || {}).id || this.clientData.go_ops;
        if (
          this.clientData.go_ops == undefined ||
          this.clientData.go_ops == ""
        ) {
          this.clientData.go_ops = null;
        }
        this.clientData.go_marketing =
          (this.clientData.go_marketing || {}).id ||
          this.clientData.go_marketing;
        if (
          this.clientData.go_marketing == undefined ||
          this.clientData.go_marketing == ""
        ) {
          this.clientData.go_marketing = null;
        }
        this.clientData.client_main_contact =
          (this.clientData.client_main_contact || {}).id ||
          this.clientData.client_main_contact;
        if (
          this.clientData.client_main_contact == undefined ||
          this.clientData.client_main_contact == ""
        ) {
          this.clientData.client_main_contact = null;
        }
        this.clientData.go_brand =
          (this.clientData.go_brand || {}).id ||
          this.clientData.go_brand;
        if (
          this.clientData.go_brand == undefined ||
          this.clientData.go_brand == ""
        ) {
          this.clientData.go_brand = null;
        }
        this.clientData.go_dsp =
          (this.clientData.go_dsp || {}).id ||
          this.clientData.go_dsp;
        if (
          this.clientData.go_dsp == undefined ||
          this.clientData.go_dsp == ""
        ) {
          this.clientData.go_dsp = null;
        }
        this.clientData.go_media =
          (this.clientData.go_media || {}).id ||
          this.clientData.go_media;
        if (
          this.clientData.go_media == undefined ||
          this.clientData.go_media == ""
        ) {
          this.clientData.go_media = null;
        }
        this.clientData.go_content =
          (this.clientData.go_content || {}).id ||
          this.clientData.go_content;
        if (
          this.clientData.go_content == undefined ||
          this.clientData.go_content == ""
        ) {
          this.clientData.go_content = null;
        }
        this.clientData.go_ba =
          (this.clientData.go_ba || {}).id ||
          this.clientData.go_ba;
        if (
          this.clientData.go_ba == undefined ||
          this.clientData.go_ba == ""
        ) {
          this.clientData.go_ba = null;
        }
        this.clientData.go_other =
          (this.clientData.go_other || {}).id ||
          this.clientData.go_other;
        if (
          this.clientData.go_other == undefined ||
          this.clientData.go_other == ""
        ) {
          this.clientData.go_other = null;
        }
        if (
          this.clientData.go_initiative == undefined ||
          this.clientData.go_initiative == ""
        ) {
          this.clientData.go_initiative = null;
        }

        this.loader = true;
        let payload={
          instacarts:[],
          vendors:[],
          sellers:[],
          adAccounts:[],
          DSP:[],
          go_client_id:this.client_id,
          clientData: this.clientData,
        }
          console.log('saveData: - PAYLOAD - ', payload);
        this.profileData.forEach(section=>{
          console.log(section.type);
          if(section.type == "Instacart Accounts"){
            payload.instacarts.push({
              disable_date: section.disable_date,
              instacart_profile_id: section.selected_profile.instacart_profile_id,
              instacart_profile_name: section.selected_profile.instacart_profile_name,
              active: section.active,
              profile_id: section.profile_id,
              prev_go_client_id:section.prev_go_client_id
            })
          }
          else if(section.type =="Seller"){
            payload.sellers.push({
              disable_date: section.disable_date,
              merchant_id: section.selected_profile.merchant_id,
              country_code: section.country_code,
              merchant_name: section.selected_profile.merchant_name,
              annual_goal: section.annual_goal,
              active: section.active,
              fba: section.fba,
              id: section.id,
              prev_go_client_id: section.prev_go_client_id,
              partner_uuid: section.partner_uuid,
              go_ops: (section.go_ops||{}).id || null,
              go_retail: (section.go_retail||{}).id || null,
              go_marketing: (section.go_marketing||{}).id || null
            })
          }
          else if(section.type =="Vendor"){
            payload.vendors.push({
              vendor_name: section.selected_profile.vendor_name,
              vendor_id: section.selected_profile.vendor_id,
              country_code: section.country_code,
              active: section.active,
              id: section.id,
              disable_date: section.disable_date,
              annual_goal: section.annual_goal,
              prev_go_client_id:section.prev_go_client_id,
              partner_uuid: section.partner_uuid,
              go_ops: (section.go_ops||{}).id || null,
              go_retail: (section.go_retail||{}).id || null,
              go_marketing: (section.go_marketing||{}).id || null
            })
          }
          else if(section.type=='DSP Accounts'){
            payload['DSP'].push({
              "advertiser_name": section.selected_profile.advertiser_name,
              "advertiser_id": section.selected_profile.advertiser_id,
              "active": section.active||false,
              "disable_date": section.disable_date,
              "prev_go_client_id":section.prev_go_client_id
            }) 
          }
          else if(section.type=='Ad Accounts'){
            payload.adAccounts.push({
              profile_brand_name:section.profile_brand_name ,
              brand_entity_id:section.brand_entity_id,
              country_code:section.country_code,
              monthly_budget: this.unformatBudget(section.monthly_budget),
              marketing_campaign_sb: section.marketing_campaign_sb,
              marketing_campaign_sp: section.marketing_campaign_sp,
              marketing_campaign_sd: section.marketing_campaign_sd,
              active: section.active,
              disable_date: section.disable_date,
              profile_id: section.profile_id,
              prev_go_client_id:section.prev_go_client_id,
              data_pull: section.data_pull,
              api_account_email: section.api_account_email
            })
          }

        })
        // return 
        this.$store.dispatch("accounts/saveAccountData", payload).then(res=>{
          if(res){
            vm.loader = false;
            vm.navigateToListPage();
          }
		    });
      }
    },
    unformatBudget(val){
      let budget = val? val.split(','):["0.00"]
      return budget.join('')
    },
    validateClient(moveToTop){
      if(!this.clientData || !this.clientData.client || !this.clientData.client.client_name || !this.clientData.client.client_id){
        if(moveToTop){
          $(document).ready(function () {
            $(window).scrollTop(0);
          });
        }
        return false
      }
      else{
        return true
      }
    },
    validateSections(){
      for(var i =0; i<this.profileData.length; i++)
      {
        let section = this.profileData[i]
        if(section.type=='Seller' && (!section.selected_profile || !section.selected_profile.merchant_name || !section.selected_profile.merchant_id || !section.country_code)){
          return false
        }
        else if(section.type=='Vendor' && (!section.selected_profile || !section.selected_profile.vendor_name || !section.selected_profile.vendor_id || !section.country_code)){
          return false
        }
        else if(section.type=='DSP Accounts' && (!section.selected_profile || !section.selected_profile.advertiser_name || !section.selected_profile.advertiser_id) ){
          return false
        }
        else if(section.type=='Instacart Accounts' && (section.duplicateProfile || !section.selected_profile|| !section.selected_profile.instacart_profile_name || !section.selected_profile.instacart_profile_id))
        {
          return false
        }
        else if(section.type=='Ad Accounts' && (section.duplicateProfile || !section.profile_brand_name || !section.brand_entity_id || !section.country_code ||!(true || section.marketing_campaign_sp || section.marketing_campaign_sb || section.marketing_campaign_sd))){
          return false
        }
      }
      return true
    },
    validate() {
      let isAllSellerVendorAdded = this.profileData.find(
        (e) =>
          (e.profile_type_seller && !e.seller) ||
          (e.profile_type_vendor && !e.vendor)
      );

      let isDuplicateProfileId = this.profileData.find(
        (e) => e.duplicateProfile
      );

      let profileValidation = this.profileData.find((e) => !e.brand_entity_id);
      if (profileValidation) {
        let indx = this.profileData.indexOf(profileValidation);
        this.profileData[indx].noData = true;
      }

      let checkIsActiveFlagAndNoData = this.profileData.find(
        (e) => e.active && !e.seller && !e.vendor
      );

      if (checkIsActiveFlagAndNoData) {
        this.activeProfileWithoutData = true;
      } else {
        this.activeProfileWithoutData = false;
      }

      let checkDateForProfile = this.profileData.find(
        (e) => e.active == false && e.disable_date == null && e.showDate
      );

      if (checkDateForProfile) {
        this.noDateForActiveFalse = this.profileData.indexOf(
          checkDateForProfile
        );
      } else {
        this.noDateForActiveFalse = -1;
      }

      if (isAllSellerVendorAdded) {
        this.profileWithoutData = true;
      } else {
        this.profileWithoutData = false;
      }

      if (
        !this.clientData.client_name &&
        (!this.clientData.client ||
          (this.clientData.client && !this.clientData.client.client_name))
      ) {
        $(document).ready(function () {
          $(window).scrollTop(0);
        });
      }

      if (
        (!this.clientData.client_name &&
          (!this.clientData.client ||
            (this.clientData.client && !this.clientData.client.client_name))) ||
        isAllSellerVendorAdded ||
        profileValidation ||
        isDuplicateProfileId ||
        checkIsActiveFlagAndNoData ||
        checkDateForProfile
      ) {
        return false;
      } else {
        return true;
      }
    },
    fetchAllAmSections(){
      //set client and other sections data here
      let vm = this
      this.loader = true
            this.$store.dispatch("accounts/getAccountSections",{go_client_id:this.client_id}).then(res=>{
              vm.loader = false
              // let res = this.accountResponse
              vm.profileData =(res && res.profileData && res.profileData.length) ? res.profileData : [];
              if(vm.profileData.length){
                this.setAccountSections()
              }
              vm.clientData =
                res && res.clientData
                  ? res.clientData
                  : { client: {}, client_name: "" };

              if (vm.clientData) {
                vm.setClientData(res.clientData);
              }

            })
            
    },
    getProfileData() {
      //fetch client and other sections
      this.fetchAllAmSections()
      return
      let vm = this;
      if (this.client_id) {
        this.loader = true;

        if (this.profileData.length > 1) {
          this.tempProfile = this.profileData[0];
        }

        this.$store
          .dispatch("accounts/getDetails", { client_id: this.client_id })
          .then((res) => {
            vm.loader = false;
            vm.profileData =
              res && res.profileData && res.profileData.length
                ? res.profileData
                : [];

            if (Object.keys(vm.tempProfile).length) {
              vm.profileData.push(vm.tempProfile);
            }
            if (
              vm.profileData.length &&
              vm.profileData.length > 1 &&
              vm.currentProfile
            ) {
              let data = vm.profileData.find(
                (e) => e.profile_id == vm.currentProfile
              );
              let index = vm.profileData.indexOf(data);
              if (index != -1) {
                vm.profileData.splice(index, 1);
                vm.profileData.unshift(data);
              }
            }

            if (vm.profileData.length) {
              vm.setProfileData(vm.profileData);
            }
            vm.clientData =
              res && res.clientData
                ? res.clientData
                : { client: {}, client_name: "" };

            if (vm.clientData) {
              vm.setClientData(res.clientData);
            }
          });
      }
    },
    setAccountSections(){
      let vm = this;
      this.profileData.map((e,index) => {
        if(e.type=='Seller'){
          let selectedSeller = vm.sellerListCopy.find(
            (seller) => seller.id == e.id
          );
          vm.convertToUniqueSellerDataSet(
            e.id,
            "add"
          );
          vm.profileData[index].selected_profile = selectedSeller;
          if (e && e.disable_date) {
            vm.profileData[index].showDate = true;
            vm.profileData[index].disable_date = e.disable_date;
          }
          vm.profileData[index].prev_go_client_id = this.client_id
        }
        if(e.type=='Vendor'){
          let selectedVendor = vm.vendorListCopy.find(
            (vendor) => vendor.vendor_id == e.vendor_id
          );
          vm.convertToUniqueVendorDataSet(
            e.vendor_id,
            "add"
          );
          vm.profileData[index].selected_profile = selectedVendor;
          if (e && e.disable_date) {
            vm.profileData[index].showDate = true;
            vm.profileData[index].disable_date = e.disable_date;
          }
          vm.profileData[index].prev_go_client_id = this.client_id
        }
        if(e.type=='Instacart Accounts'){
          let selectedInsta = vm.instacartsCopy.find(
            (insta) => insta.instacart_profile_id == e.instacart_profile_id
          );
          vm.convertToUniqueInstaCartDataSet(
            e.instacart_profile_id,
            "add"
          );
          vm.profileData[index].selected_profile = selectedInsta;
          if (e && e.disable_date) {
            vm.profileData[index].showDate = true;
            vm.profileData[index].disable_date = e.disable_date;
          }
          vm.profileData[index].prev_go_client_id = this.client_id
        }
        if(e.type=='Ad Accounts'){
          let selectedBrand = vm.brandsListCopy.find(
            (brand) => brand.id == e.profile_id
          );
          vm.profileData[index].selected_profile = selectedBrand;
          vm.convertToUniqueDataSet(
            e.profile_id,
            "add"
          );
          if (e && e.disable_date) {
            vm.profileData[index].showDate = true;
            vm.profileData[index].disable_date = e.disable_date;
          }
          
          vm.profileData[index]["profile_brand_name"] = vm.profileData[index].selected_profile["name"];
          let name = vm.profileData[index].selected_profile["name"]
            ? vm.profileData[index].selected_profile["name"] + " ("
            : "";
          name =
            name +
            vm.profileData[index].selected_profile["brand_entity_id"] +
            (vm.profileData[index].selected_profile["name"] ? ")" : "");
          vm.profileData[index].selected_profile["customName"] = name;
          vm.profileData[index].showProfileInfo = true;
          vm.profileData[index].gettingProfileInfo = false;
          vm.profileData[index].prev_go_client_id = this.client_id
        }
        if(e.type=='DSP Accounts'){
          let selectedDsp = vm.DSPCopy.find(
            (dsp) => dsp.advertiser_id == e.advertiser_id
          );
          vm.convertToUniqueDSPDataSet(
            e.advertiser_id,
            "add"
          );
          vm.profileData[index].selected_profile = selectedDsp;
          if (e && e.disable_date) {
            vm.profileData[index].showDate = true;
            vm.profileData[index].disable_date = e.disable_date;
          }
          vm.disableDSP = true
          vm.profileData[index].prev_go_client_id = this.client_id
        }
      })
    },
    setProfileData() {
      let vm = this;
      this.profileData.map((e, index) => {
        let seletedData = vm.brandsListCopy.find(
          (brand) => brand.id == e.profile_id
        );
        let brandsData = vm.brandsList.find(
          (brand) => brand.brand_entity_id == e.brand_entity_id
        );
        let brandIndex = vm.brandsList.indexOf(brandsData);
        vm.brandsList.splice(brandIndex, 1);
        vm.profileData[index].selected_profile = true;
        vm.profileData[index].showProfileInfo = true;
        vm.profileData[index].selected_profile = seletedData;
        let name = vm.profileData[index].selected_profile["name"]
          ? vm.profileData[index].selected_profile["name"] + " ("
          : "";
        name =
          name +
          vm.profileData[index].selected_profile["brand_entity_id"] +
          (vm.profileData[index].selected_profile["name"] ? ")" : "");
        vm.profileData[index].selected_profile["customName"] = name;
        if (e.profile_type && e.profile_type.toLowerCase() == "seller") {
          e.showSeller = true;
        }
        if (e.merchant_name && e.merchant_id) {
          let sellerData = vm.sellerList.find(
            (seller) => e.merchant_id == seller.merchant_id
          );
          if (sellerData) {
            this.profileData[index].seller = sellerData;
            this.profileData[index].seller.seller = {
              merchant_name: sellerData.merchant_name,
              merchant_id: sellerData.merchant_id,
            };
          }

          // let indx = vm.sellerList.indexOf(sellerData)
          // vm.sellerList.splice(indx, 1)
        }
        if (e.profile_type && e.profile_type.toLowerCase() == "vendor") {
          e.showVendor = true;
        }
        if (e.vendor_id) {
          let vendorData = vm.vendorList.find(
            (vendor) => e.vendor_id == vendor.vendor_id
          );
          if (vendorData) {
            this.profileData[index].vendor = vendorData;
            this.profileData[index].vendor.vendor = {
              vendor_name: vendorData.vendor_name,
              id: vendorData.id,
              vendor_id: vendorData.vendor_id,
            };
          }
        }
        if (e && e.disable_date) {
          vm.profileData[index].showDate = true;
          vm.profileData[index].disable_date = e.disable_date;
        }
        vm.profileData[index].gettingProfileInfo = false;
      });

      this.vendorList.splice(0, 0);
      this.sellerList.splice(0, 0);
      this.profileData.splice(0, 0);
    },
    setClientData(data) {
      console.log('setClientData: Input Data - ', data, 'Client - ', this.clientData)
      this.clientData.client = {
        client_name: data.client_name,
        client_id: data.client_id,
      };
    },
    newVendorAddedName(data) {
      this.addedNewVendor = data;
    },
    newSellerAddedName(data) {
      this.addedNewSeller = data;
    },
    removeSelected(type, index) {
      if (type == "vendor") this.profileData[index].vendor = null;
      else if (type == "seller") this.profileData[index].seller = null;

      let data = JSON.parse(JSON.stringify(this.profileData));
      this.profileData = JSON.parse(JSON.stringify(data));
    },
    removeDate(index) {
      this.profileData[index].disable_date = "";
      this.profileData[index].showDate = false;
    },
  },
};
</script>

<style lang="scss">
.change-color {
  background-color: #f6f8f7;
  border: 1px #27c475 solid !important;
}
.date_wrapper {
  .text-muted {
    border: 0px;
    margin: 0px;
  }
}

.date_wrapper {
  .text-break {
    border: none;
    margin: 0px;
  }
}
::placeholder {
  color: #aaa !important;
  font-size: 14px;
}
.vendor-form-wrapper {
  .divider {
    border-bottom: 2px solid #115E67;
    // margin-bottom: 10px;
    font-size: 20px;
    padding: 5px 0px 0px 5px;
    margin-top: 30px;
  }
  .btn-margin {
    margin-left: 0px !important;
    margin-right: 15px !important;
  }
}
</style>
